export default {
  label: {
    title: {
      modal: 'Excluir dashboard permanentemente?',
    },
    button: {
      primaryButtonLabel: 'Excluir',
      secondaryButtonLabel: 'Cancelar',
    },
  },
  text: {
    modalTextBody: 'Se você excluir este dashboard, não será possível recuperá-lo. Deseja excluí-lo mesmo assim?',
  },
};
